// extracted by mini-css-extract-plugin
export default {"BngCodeMirrorWrapper":"_7qnHVDY1e0HW-ZEmpIxJPQ=="};